import {gsap}from "gsap";
import {ScrollTrigger}from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const setupBenefitsAnimation=(sectionRef,introRef)=>{
  const section=sectionRef.current;
  const intro=introRef?.current;

  if(!section){
    return()=>{};
  }

  const cards=Array.from(
    section.querySelectorAll(".autobet-benefit-card")
  );

  if(!cards.length){
    return()=>{};
  }

  let ticking=false;

  const updateCards=()=>{
    if(ticking){
      return;
    }

    ticking=true;

    requestAnimationFrame(()=>{
      const viewportCenter=window.innerHeight*.55;
      const maxDist=window.innerWidth<=600?280:260;

      let closestCard=null;
      let closestDistance=Infinity;

      cards.forEach(card=>{
        const rect=card.getBoundingClientRect();
        const cardCenter=rect.top+rect.height/2;
        const distance=Math.abs(cardCenter-viewportCenter);

        if(
          rect.bottom>0&&
          rect.top<window.innerHeight&&
          distance<closestDistance
        ){
          closestDistance=distance;
          closestCard=card;
        }
      });

      if (window.innerWidth <= 700) {
        cards.forEach((card) => {
          card.classList.toggle("is-active", card === closestCard);
          gsap.set(card, { clearProps: "all" });
        });
        ticking=false;
        return;
      }

      cards.forEach((card,index)=>{
        card.classList.toggle(
          "is-active",
          card===closestCard
        );

        const rect=card.getBoundingClientRect();
        const cardCenter=rect.top+rect.height/2;
        const distanceFromCenter=cardCenter-viewportCenter;

        let normalized=Math.max(
          -2,
          Math.min(
            2,
            distanceFromCenter/maxDist
          )
        );

        /*
         * Keep the last card stable when it reaches
         * the center and the user continues scrolling.
         */
        if(
          index===cards.length-1&&
          distanceFromCenter<0
        ){
          normalized=0;
        }

        const distance=Math.abs(normalized);

        let scale=.94;
        let opacity=.5;
        let rotateX=0;
        let translateY=0;

        if(distance<=1){
          scale=1-(distance*.06);
          opacity=1-(distance*.3);

          /*
           * Very subtle depth effect.
           * Kept low so the cards don't look like
           * they're bending or jumping.
           */
          rotateX=
            -Math.sign(normalized)*
            (distance*20);

          translateY=normalized*-5;
        }else{
          scale=.94;
          opacity=.65;

          rotateX=
            -Math.sign(normalized)*
            ((2-distance)*20);

          translateY=
            Math.sign(normalized)*-5;
        }


        gsap.to(card,{
          duration: 0.4,
          ease: "power2.out",
          scale,
          opacity,
          rotateX,
          y:translateY,
          transformPerspective:1400,
          overwrite: "auto"
        });
      });

      ticking=false;
    });
  };

  const updatePadding = () => {
    const cardsWrapper = section.querySelector('.benefits-cards-wrapper');
    if (cardsWrapper && intro) {
      cardsWrapper.style.paddingTop = `${intro.offsetHeight}px`;
    }
  };

  const resizeHandler = () => {
    updateCards();
    updatePadding();
  };

  window.addEventListener(
    "scroll",
    updateCards,
    {passive:true}
  );

  window.addEventListener(
    "resize",
    resizeHandler
  );

  const ctx=gsap.context(()=>{

    updatePadding();

    if (intro) {
      ScrollTrigger.create({
        trigger: section,
        start: () => window.innerWidth <= 700 ? "top top+=75" : "top top",
        end: "bottom bottom",
        pin: intro,
        pinSpacing: false
      });
    }

    /*
     * Fade the supporting header description
     * as the cards begin entering.
     */
    const description=section.querySelector(
      ".benefits-description"
    );

    if(description){
      gsap.to(description,{
        opacity:0,
        y:-15,
        ease:"none",
        scrollTrigger:{
          trigger:section,
          start:"top top",
          end:"+=200",
          scrub:true,
        },
      });
    }

    updateCards();
    ScrollTrigger.refresh();
  },section);

  return()=>{
    window.removeEventListener(
      "scroll",
      updateCards
    );

    window.removeEventListener(
      "resize",
      resizeHandler
    );

    ctx.revert();
  };
};